import { useId } from "react";
import { InputText } from "primereact/inputtext";
import { AutoComplete } from "primereact/autocomplete";
import { Message } from 'primereact/message';

export function NewStopForm({values, onChangeStopId, onChangeStopName}) {
  formId = useId();
  return (
    <>
      <div className="field grid">
        <label for={formId + '_stop_id'} className="col-fixed" style={{width: '40%'}}>ID nowego przystanku</label>
        <div className="col w-auto">
          <InputText 
            id={formId + '_stop_id'} 
            value={values.stop_id} 
            style="w-100" 
            onChange={onChangeStopId} 
            invalid={Boolean(values.validation_errors.stop_id)}
          />
          {
            (values.validation_errors.stop_id) 
            ?
              <Message severity="error" className='mt-1' text={values.validation_errors.stop_id} />
            :
              <></>
          }
        </div>
      </div>
      <div className="field">
        <label for={formId + '_stop_name'}>Nazwa nowego przystanku</label>
        <AutoComplete 
          className="w-full" 
          inputClassName="w-full" 
          value={values.stop_name} 
          id={formId + '_stop_name'} 
          placeholder={values.stop_name_placeholder} 
          onChange={onChangeStopName}
          invalid={Boolean(values.validation_errors.stop_name)}
        >
        </AutoComplete>
        {
            (values.validation_errors.stop_name) 
            ?
              <Message severity="error" className='mt-1' text={values.validation_errors.stop_name} />
            :
              <></>
        }
      </div>
    </>
  );
}




